import React, { Component } from 'react';
import { Trans } from 'react-i18next';
import { FormikProps } from 'formik';
import { Button, Grid } from '@material-ui/core';
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core/styles';

import { GroupStatus } from 'api';
import { Alert } from 'components';

import { IGroupForm } from '../../types';

interface IProps extends WithStyles<typeof styles> {
  hexColor: string;
  formikProps: FormikProps<IGroupForm>;
  showDelete: boolean;
}

interface IState {
  deleteOpen: boolean;
}

const styles = ({ palette }: Theme) =>
  createStyles({
    doneButton: {
      transition: 'opacity 150ms ease-in-out',
      borderColor: 'transparent',
      color: palette.common.white,
      '&:hover': {
        opacity: 0.9,
        borderColor: 'transparent',
      },
    },
    deleteButton: {
      transition: 'opacity 150ms ease-in-out',
      color: palette.text.hint,
      '&:hover': {
        backgroundColor: 'transparent',
        opacity: 0.7,
      },
    },
  });

class Actions extends Component<IProps, IState> {
  state: IState = {
    deleteOpen: false,
  };

  handleDeleteToggle = () => {
    const { deleteOpen } = this.state;
    this.setState({ deleteOpen: !deleteOpen });
  };

  handleDelete = () => {
    const { formikProps } = this.props;

    this.setState({ deleteOpen: false }, () => {
      formikProps.setFieldValue('group_status', GroupStatus.Deleted);
    });
  };

  renderDeleteAlert() {
    const { deleteOpen } = this.state;

    return (
      <Alert
        open={deleteOpen}
        onConfirm={this.handleDelete}
        onCancel={this.handleDeleteToggle}
        message={<Trans i18nKey="groups:deleteGroupAlert" />}
        confirm={<Trans i18nKey="common:delete" />}
      />
    );
  }

  renderDoneButton() {
    const { classes, hexColor } = this.props;

    return (
      <Button
        className={classes.doneButton}
        style={{ backgroundColor: hexColor }}
        fullWidth
        size="large"
        type="submit"
        variant="contained">
        <Trans i18nKey="common:done" />
      </Button>
    );
  }

  renderDeleteButton() {
    const { classes } = this.props;

    return (
      <Button
        className={classes.deleteButton}
        fullWidth
        size="large"
        variant="outlined"
        onClick={this.handleDeleteToggle}>
        <Trans i18nKey="groups:deleteGroup" />
      </Button>
    );
  }

  render() {
    const { showDelete } = this.props;

    return (
      <Grid container direction="column" spacing={2}>
        <Grid item>{this.renderDoneButton()}</Grid>
        {showDelete && (
          <Grid item>
            {this.renderDeleteButton()}
            {this.renderDeleteAlert()}
          </Grid>
        )}
      </Grid>
    );
  }
}

export default withStyles(styles)(Actions);
